// extracted by mini-css-extract-plugin
export default {"dialog":"_11ysb","buttonClose":"_3JCKC","buttonActionBox":"_72Laz","dialogContent":"MTPPg"};